import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, HeartHandshakeIcon, SproutIcon, UsersIcon } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { SectionLabel } from '../components/SectionLabel';
const PORTRAIT = 'https://cdn.magicpatterns.com/uploads/mfkSPhgM5yuYZU3TnjoZM3/3918907D-A98D-4CB0-AF95-E1F81CBD0CD9.jpg';
const VALUES = [{
  title: 'Where nature and yoga meet',
  text: 'Practice belongs outdoors: on the sand, under open sky, with the ocean keeping time. PARṆA exists to put those two loves in the same place.',
  Icon: SproutIcon
}, {
  title: 'A community that shows up',
  text: 'Not a studio you pass through, but people who know your name, save you a spot on the sand, and notice when you have been away.',
  Icon: UsersIcon
}, {
  title: 'Leaving it better',
  text: 'Beach cleanups, fundraisers, and days of service alongside our classes. The practice does not end when we roll up the mat.',
  Icon: HeartHandshakeIcon
}];
export function About() {
  return <main className="w-full bg-cream" data-id="element-176" data-mp="1ujw8hk2yhqbm">
      <section className="w-full bg-cream px-6 pb-16 pt-40 text-center md:px-10 md:pb-20 md:pt-48" data-id="element-177" data-mp="1pj8kl7a0xplm">
        <Reveal data-id="element-178" data-mp="23iqbbs6vrcxm">
          <SectionLabel data-id="element-179" data-mp="23jjc8cj5r87u">About</SectionLabel>
        </Reveal>
        <Reveal delay={0.1} data-id="element-180" data-mp="1yjn4q3b94ynj">
          <h1 className="mt-6 font-display text-4xl font-light leading-[1.1] text-ink sm:text-6xl" data-id="element-181" data-mp="1yic1q5pmruxh">
            Hi, I&rsquo;m <span className="italic text-clay" data-id="element-182" data-mp="2dfct283wtnvf">Jenna Wing</span>
          </h1>
        </Reveal>
        <Reveal delay={0.16} data-id="element-183" data-mp="28grsu8onr46z">
          <p className="mt-5 text-[11px] font-light uppercase tracking-ultra text-muted" data-id="element-184" data-mp="28fgoo7ravufc">
            Founder &amp; teacher
          </p>
        </Reveal>
      </section>

      <section className="w-full bg-cream pb-24 md:pb-32" data-id="element-185" data-mp="2i8nqjimu0sao">
        <div className="mx-auto grid max-w-[1400px] items-start gap-14 px-6 md:grid-cols-[0.9fr_1.1fr] md:gap-20 md:px-10" data-id="element-186" data-mp="2w6vuiaiactvc">
          <Reveal data-id="element-187" data-mp="2r93uet7hm1g2">
            <img src={PORTRAIT} alt="Jenna Wing standing on the sand at golden hour, arms open in a flowing white outfit" className="aspect-[4/5] w-full object-cover object-[center_30%]" data-id="element-188" data-mp="2r9lygc0e5jyj" />
          </Reveal>

          <div data-id="element-189" data-mp="1xut037qvq6h2">
            <Reveal data-id="element-190" data-mp="1xu9sokyuv0ha">
              <SectionLabel align="left" data-id="element-191" data-mp="1xtrrrb18zy31">My story</SectionLabel>
            </Reveal>

            <Reveal delay={0.1} data-id="element-192" data-mp="22mt8lol0m7p9">
              <h2 className="mt-8 font-display text-4xl font-light leading-[1.15] text-ink sm:text-5xl" data-id="element-193" data-mp="22o47pb3imra1">
                Nature is my
                <br data-id="element-194" data-mp="2cjph3uawyttt" />
                <span className="italic text-clay" data-id="element-195" data-mp="2cj61ik8qkhiy">home</span>
              </h2>
            </Reveal>

            <div className="mt-8 max-w-prose space-y-5 text-[15px] font-light leading-[1.9] text-muted" data-id="element-196" data-mp="2gmvj2pqztyuh">
              <Reveal delay={0.16} data-id="element-197" data-mp="2ljm31o5x5el6">
                <p data-id="element-198" data-mp="2lij9f8h7oy1k">
                  Under the open sky, beneath the waves, under the trees. That is where I feel
                  most like myself. I grew up on the coast in Hermosa Beach, California, and the
                  natural world has always been less a place I visit than the place I belong to.
                </p>
              </Reveal>
              <Reveal delay={0.2} data-id="element-199" data-mp="evlmbny549x4">
                <p data-id="element-200" data-mp="eujzynboc103">
                  I try to move through life awake to it. There is so much beauty in this world,
                  and most of it is quiet: the light shifting on the water, the pause between two
                  breaths. Presence is the practice that lets me notice, and I&rsquo;ve long wanted
                  to build a way for all of us to live more intertwined with the world around us.
                </p>
              </Reveal>
              <Reveal delay={0.24} data-id="element-201" data-mp="sn9wvmsqqqbz">
                <p data-id="element-202" data-mp="sm8e0w5hgzjp">
                  Then I fell in love with yoga. It grounded me, not just in my body but in the universe I’m a part of. It gave me the language for what I’d always felt outside: that we were never separate from any of this.
                </p>
              </Reveal>
              <Reveal delay={0.28} data-id="element-203" data-mp="39b42m959uugc">
                <p data-id="element-204" data-mp="113z6z6ib7weg">
                  I built PARṆA to be that puzzle piece, the one that connects humans and nature,
                  movement and stillness. I&rsquo;m so happy you&rsquo;re here, and I hope you find
                  your wings while staying grounded and fully in your presence.
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-shell py-24 md:py-32" data-id="element-205" data-mp="1jugw713xo9v2">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10" data-id="element-206" data-mp="1jv037ms1pdub">
          <Reveal data-id="element-207" data-mp="1ottjfmypviy6">
            <SectionLabel data-id="element-208" data-mp="1os8ovxcek00b">What I&rsquo;m building</SectionLabel>
          </Reveal>
          <Reveal delay={0.08} data-id="element-209" data-mp="1auk1oiuv4gs3">
            <h2 className="mt-7 text-center font-display text-4xl font-light text-ink sm:text-5xl" data-id="element-210" data-mp="1at92yxg9xz7u">
              A practice that gives back
            </h2>
          </Reveal>
          <Reveal delay={0.14} data-id="element-211" data-mp="3viyccuy7kst5">
            <p className="mx-auto mt-6 max-w-xl text-center text-[15px] font-light leading-[1.9] text-muted" data-id="element-212" data-mp="3viq2lbxdu3m6">
              I wanted more than a place to practice. I wanted a community that takes care of the
              coastline it practices on and of each other, and leaves this world a little better
              than we found it.
            </p>
          </Reveal>

          <ul className="mt-16 grid gap-px overflow-hidden bg-clay/15 md:grid-cols-3" data-id="element-213" data-mp="5tkjp3nfbfhq">
            {VALUES.map((value, i) => <Reveal as="li" key={value.title} delay={0.06 * i} className="group bg-shell p-9 transition-colors duration-500 hover:bg-cream md:p-11" data-id="element-214" data-mp="tprmwrwwjv3" data-mpi={i}>
                <value.Icon className="h-5 w-5 text-clay" strokeWidth={1.25} aria-hidden="true" data-id="element-215" data-mp="3j15i74muhodb" />
                <h3 className="mt-6 font-display text-2xl font-light leading-snug text-ink" data-id="element-216" data-mp="3eayt73of81uj">
                  {value.title}
                </h3>
                <p className="mt-4 text-[14px] font-light leading-[1.85] text-muted" data-id="element-217" data-mp="2qjjnr21cl4f2">
                  {value.text}
                </p>
              </Reveal>)}
          </ul>
        </div>
      </section>

      <section className="w-full bg-cream py-24 md:py-32" data-id="element-218" data-mp="3b9x3kjclnue3">
        <div className="mx-auto max-w-2xl px-6 text-center md:px-10" data-id="element-219" data-mp="3faz5j7xwikjr">
          <Reveal data-id="element-220" data-mp="3k2quje1esi7s">
            <p className="font-display text-2xl font-light italic leading-[1.5] text-ink sm:text-[2rem]" data-id="element-221" data-mp="3k27b1sw41lrn">
              &ldquo;I hope you find your wings while staying grounded, right here, fully in your
              presence.&rdquo;
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-222" data-mp="2wcwk134kb5qp">
            <p className="mt-8 text-[11px] font-light uppercase tracking-ultra text-clay" data-id="element-223" data-mp="2wc4ofsayt80f">
              Jenna Wing
            </p>
          </Reveal>

          <Reveal delay={0.18} data-id="element-224" data-mp="31e2ep6hs932v">
            <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-225" data-mp="36blq7yn3j1r4">
              <Link to="/" state={{
              scrollTo: 'connect'
            }} className="group inline-flex items-center gap-3 rounded-full border border-clay/40 px-8 py-4 text-[10px] font-light uppercase tracking-ultra text-clay transition-colors duration-500 hover:bg-clay hover:text-cream" data-id="element-226" data-mp="gm0h4e3hz2w2">
                Join the community
                <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-500 group-hover:translate-x-1" strokeWidth={1.5} aria-hidden="true" data-id="element-227" data-mp="2165deyu0vgra" />
              </Link>
              <Link to="/" state={{
              scrollTo: 'schedule'
            }} className="text-[10px] font-light uppercase tracking-ultra text-muted transition-colors duration-300 hover:text-clay" data-id="element-228" data-mp="1nco384n87gdx">
                See the schedule
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>;
}